import React, { FunctionComponent } from "react";
import { Badge, Skeleton, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}

export const DISCONNECT_POINT_STATUS = {
  NONE: 0,
  CONNECTED: 1,
  DISCONNECTED: 2,
  TRIPPED: 3,
}


const DisconnectPointStatus: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case DISCONNECT_POINT_STATUS.NONE:
      return (
        <Badge variant={"outline"} colorScheme={"gray"} title={intl.formatMessage({
            id: "command__disconnect_point__status__none",
            defaultMessage: "No state",
          })}>
          <Box display="inline-block" w="2" h="3" />
        </Badge>
      )
    case DISCONNECT_POINT_STATUS.CONNECTED:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "command__disconnect_point__status__connected",
            defaultMessage: "CONNECTED",
          })}
        </Badge>
      )
    case DISCONNECT_POINT_STATUS.DISCONNECTED:
      return (
        <Badge variant="solid" colorScheme={"gray"}>
          {intl.formatMessage({
            id: "command__disconnect_point__status__disconnected",
            defaultMessage: "DISCONNECTED",
          })}
        </Badge>
      )
    case DISCONNECT_POINT_STATUS.TRIPPED:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "command__disconnect_point__status__tripped",
            defaultMessage: "TRIPPED",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default DisconnectPointStatus;
